import {
    SET_ASSET_TYPE, SET_NON_REQUISITION_ASSET_TYPE,
} from "./AssetTypeType";

const initialState = {
    assetTypeDropDown: []
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ASSET_TYPE:
            return {
                ...state,
                AssetType: action.assetType,
            };
        case SET_NON_REQUISITION_ASSET_TYPE:
            return {
                ...state,
                NonRequisitionAssetType: action.assetType,
            };
        default:
            return state;
    }
};

export default reducer;
